/* eslint-disable react/require-default-props */
import React from 'react';
import ReactInputMask, {
  BeforeMaskedStateChangeStates,
  InputState,
} from 'react-input-mask';

interface CurrencyProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputRef?: React.Ref<HTMLInputElement> | undefined;
  ref?: React.LegacyRef<ReactInputMask> | undefined;
  beforeMaskedStateChange?(states: BeforeMaskedStateChangeStates): InputState;
}

const PhoneInputMask = ({ ref, ...props }: CurrencyProps): JSX.Element => (
  <ReactInputMask
    {...props}
    mask="999 99 99 99"
    alwaysShowMask={false}
    maskPlaceholder=""
    value={props.value || ''}
    maskChar={null}
  >
    {(inputProps: any) => <input {...inputProps} />}
  </ReactInputMask>
);

export default PhoneInputMask;
